import { getApexDomain } from './get-apex-domain';

const BASE_URL_HOSTNAME = import.meta.env.VITE_BASE_URL ? new URL(import.meta.env.VITE_BASE_URL).hostname : '';

export const replaceApexDomainForCurrentHost = (host: string) => {
	const currentApexDomain = getApexDomain(window.location.hostname);

	if (currentApexDomain === 'localhost') {
		return host;
	}

	return host.replace(BASE_URL_HOSTNAME, currentApexDomain);
};

export const API_HOST = replaceApexDomainForCurrentHost(import.meta.env.VITE_API_HOST || '');
export const METRICS_HOST = replaceApexDomainForCurrentHost(import.meta.env.VITE_METRICS_API_HOST || '');
export const TRANSLATIONS_SERVICE_HOST = replaceApexDomainForCurrentHost(import.meta.env.VITE_TRANSLATIONS_SERVICE_HOST || '');
